import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, ArrowRight, FileText } from 'lucide-react';

const GuaranteeCard = () => (
  <section className="bg-white py-14 md:py-16" data-testid="guarantee-card">
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <div className="relative overflow-hidden rounded-3xl bg-neutral-950 text-white border-2 border-[#F39200] p-8 md:p-12">
        {/* subtle glow */}
        <div className="absolute -top-24 -right-24 w-[400px] h-[400px] rounded-full blur-3xl opacity-30" style={{ background: 'radial-gradient(closest-side, #F39200, transparent 70%)' }} />

        <div className="relative grid md:grid-cols-[auto_1fr_auto] gap-8 items-center">
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-[#F39200]/15 text-[#F39200] flex items-center justify-center shrink-0 border border-[#F39200]/30">
            <ShieldCheck size={44} />
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider text-[#F39200] font-semibold mb-2">Risk-free guarantee</div>
            <h3 className="text-2xl md:text-4xl font-extrabold leading-tight">
              100% refund if your GST isn&apos;t approved.
            </h3>
            <p className="mt-3 text-sm md:text-[15px] text-neutral-300 max-w-2xl">
              If our team fails to secure your GST registration after 3 sincere attempts due to PPOB (Principal Place of Business) issues, you pay nothing — full refund on the Virtual Office service. We back it up with a 96% first-attempt approval rate.
            </p>
            <Link
              to="/refund-policy"
              data-testid="guarantee-refund-policy-link"
              className="mt-4 inline-flex items-center gap-2 text-xs font-semibold text-[#F39200] bg-[#F39200]/10 border border-[#F39200]/30 rounded-full px-3 py-1.5 hover:bg-[#F39200]/20 transition-colors"
            >
              <FileText size={12} /> Governed by our written Refund Policy <ArrowRight size={12} />
            </Link>
          </div>
          <a
            href="#contact"
            data-testid="guarantee-cta"
            className="inline-flex items-center gap-2 bg-[#F39200] hover:bg-[#E08400] text-white h-12 px-6 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap self-start md:self-center"
          >
            Get Free Quote <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default GuaranteeCard;
